import validator from 'validator';

import inactiveCircle from '../assets/circle-solid-cultured-50.png';
import activeCircle from '../assets/circle-solid-cultured-100.png';
import activeEnvelope from '../assets/envelope-solid-cultured-100.png';
import inactiveEnvelope from '../assets/envelope-solid-cultured-50.png';
import activeAllTypes from '../assets/star-solid-cultured-100.png';
import inactiveAllTypes from '../assets/star-solid-cultured-50.png';
import activeUser from '../assets/user-solid-cultured-100.png';
import inactiveUser from '../assets/user-solid-cultured-50.png';
import activeIp from '../assets/laptop-solid-cultured-100.png';
import inactiveIp from '../assets/laptop-solid-cultured-50.png';
import activeDomain from '../assets/globe-europe-solid-cultured-100.png';
import inactiveDomain from '../assets/globe-europe-solid-cultured-50.png';
import activeHash from '../assets/hashtag-solid-cultured-100.png';
import inactiveHash from '../assets/hashtag-solid-cultured-50.png';
import activePhone from '../assets/phone-alt-solid-cultured-100.png';
import inactivePhone from '../assets/phone-alt-solid-cultured-50.png';
import activeURL from '../assets/file-code-solid-cultured-100.png';
import inactiveURL from '../assets/file-code-solid-cultured-50.png';
import activeFile from '../assets/file-solid-cultured-100.png';
import inactiveFile from '../assets/file-solid-cultured-50.png';
import activeSuitcase from '../assets/suitcase-solid-cultured-100.png';
import inactiveSuitcase from '../assets/suitcase-solid-cultured-50.png';
import activeCube from '../assets/cube-solid-cultured-100.png';
import inactiveCube from '../assets/cube-solid-cultured-50.png';
import activePin from '../assets/map-pin-solid-cultured-100.png';
import inactivePin from '../assets/map-pin-solid-cultured-50.png';
import activeCubes from '../assets/cubes-solid-cultured-100.png';
import inactiveCubes from '../assets/cubes-solid-cultured-50.png';
import activeUsers from '../assets/users-solid-cultured-100.png';
import inactiveUsers from '../assets/users-solid-cultured-50.png';
import activeExclamation from '../assets/exclamation-circle-solid-cultured-100.png';
import inactiveExclamation from '../assets/exclamation-circle-solid-cultured-50.png';
import activeSitemap from '../assets/sitemap-solid-cultured-100.png';
import inactiveSitemap from '../assets/sitemap-solid-cultured-50.png';
import activeFilePdf from '../assets/file-pdf-solid-cultured-100.png';
import inactiveFilePdf from '../assets/file-pdf-solid-cultured-50.png';
import activeKey from '../assets/key-solid-cultured-100.png';
import inactiveKey from '../assets/key-solid-cultured-50.png';
import activeChrome from '../assets/chrome-brands-cultured-100.png';
import inactiveChrome from '../assets/chrome-brands-cultured-50.png';
import activeBitcoin from '../assets/bitcoin-brands-cultured-100.png';
import inactiveBitcoin from '../assets/bitcoin-brands-cultured-50.png';
import activeBtc from '../assets/btc-brands-cultured-100.png';
import inactiveBtc from '../assets/btc-brands-cultured-50.png';
import activeBuilding from '../assets/building-solid-cultured-100.png';
import inactiveBuilding from '../assets/building-solid-cultured-50.png';
import activeFlag from '../assets/flag-solid-cultured-100.png';
import inactiveFlag from '../assets/flag-solid-cultured-50.png';
import activeCity from '../assets/city-solid-cultured-100.png';
import inactiveCity from '../assets/city-solid-cultured-50.png';
import activeId from '../assets/id-card-solid-cultured-100.png';
import inactiveId from '../assets/id-card-solid-cultured-50.png';
import activeAt from '../assets/at-solid-cultured-100.png';
import inactiveAt from '../assets/at-solid-cultured-50.png';
import activeAddress from '../assets/map-marked-alt-solid-cultured-100.png';
import inactiveAddress from '../assets/map-marked-alt-solid-cultured-50.png';
import activeFax from '../assets/fax-solid-cultured-100.png';
import inactiveFax from '../assets/fax-solid-cultured-50.png';
import activeFacebook from '../assets/facebook-square-brands-cultured-100.png';
import inactiveFacebook from '../assets/facebook-square-brands-cultured-50.png';
import activeDatabase from '../assets/database-solid-cultured-100.png';
import inactiveDatabase from '../assets/database-solid-cultured-50.png';
import activeStar from '../assets/star-of-life-solid-cultured-100.png';
import inactiveStar from '../assets/star-of-life-solid-cultured-50.png';
import activeNewspaper from '../assets/newspaper-solid-cultured-100.png';
import inactiveNewspaper from '../assets/newspaper-solid-cultured-50.png';
import activeQuote from '../assets/quote-left-solid-cultured-100.png';
import inactiveQuote from '../assets/quote-left-solid-cultured-50.png';
import activeEthereum from '../assets/ethereum-cultured-100.png';
import inactiveEthereum from '../assets/ethereum-cultured-50.png';
import activeBolt from '../assets/bolt-solid-cultured-100.png';
import inactiveBolt from '../assets/bolt-solid-cultured-50.png';

export const KEYCLOAK_REALM = process.env.REACT_APP_KEYCLOAK_REALM || 'athena';
export const KEYCLOAK_CLIENT_ID = process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'db';
export const KEYCLOAK_URL = process.env.REACT_APP_KEYCLOAK_URL || 'https://sso.athena.bitdefender.net/auth';

export const ENABLE_TIMEFILTER = process.env.REACT_APP_ENABLE_TIMEFILTER === '1';
export const ENABLE_MULTIPLE_AUTORUN = process.env.REACT_APP_ENABLE_MULTIPLE_AUTORUN === '1';
export const ENABLE_AUTO_ASN_COUNTRY = process.env.REACT_APP_ENABLE_AUTO_ASN_COUNTRY === '1';


const DB = process.env.REACT_APP_DB || 'https://db-dev.athena.bitdefender.biz';
export const ADMIN = {
  MICROSERVICES_PATH: DB + '/api/v1/admin/microservices',
  USERS_PATH: DB + '/api/v1/admin/users',
  GROUPS_PATH: DB + '/api/v1/admin/groups'
}
export const GROUP_ADMIN = {
  MICROSERVICES_PATH: DB + '/api/v1/groupadmin/microservices',
  USERS_PATH: DB + '/api/v1/groupadmin/users'
};
export const USER = {
  MICROSERVICES_PATH: DB + '/api/v1/user/microservices',
  CASES_PATH: DB + '/api/v1/user/cases',
  NOTES_PATH: DB + '/api/v1/notes',
  NOTES_GET_PATH: DB + '/api/v1/notes/nodes',

  SAVED_RESPONSES_PATH: DB + '/api/v1/user/savedresponse',
};

export const DEFAULT_STATUS = 1;
export const DEFAULT_USER_ENABLED = true;

export const DEFAULT_USER_TYPE = 'user';
export const DEFAULT_GROUP = 'guests';
export const SERVER_ERROR = 'Server error';
export const NO_RESPONSE_ERROR = 'No response received';

export const ASIDE_NODE = 'node';
export const ASIDE_EDGE = 'edge';
export const ASIDE_FETCHERS = 'fetchers';

export const CONFIRMATION_FOR_NODE_COUNT = 1000;
export const GRAPH_MODULES_LIMIT = CONFIRMATION_FOR_NODE_COUNT; // for old `Case`

export const DEFAULT_ICON_GRAPH = '/graph/circle-solid-gamboge.png';

export const types = {
  'default': {
    inactive: inactiveCircle,
    active: activeCircle,
    graph: activeCircle,
    name: 'default',
    match: (value) => false
  },
  '*': {
    inactive: inactiveAllTypes,
    active: activeAllTypes,
    graph: activeAllTypes,
    name: 'all types',
    match: (value) => true
  },
  'name': {
    inactive: inactiveUsers,
    active: activeUsers,
    graph: '/graph/users-solid-ocean-green.png',
    name: 'name',
    match: (value) => value.match(/^([A-Z]\w+(?=[\s\-][A-Z])(?:[\s\-][A-Z]\w*){1,2})$/),
  },
  'first_name': {
    inactive: inactiveUsers,
    active: activeUsers,
    graph: '/graph/users-solid-ocean-green.png',
    name: 'first name',
    match: (value) => false
  },
  'middle_name': {
    inactive: inactiveUsers,
    active: activeUsers,
    graph: '/graph/users-solid-ocean-green.png',
    name: 'middle name',
    match: (value) => false
  },
  'last_name': {
    inactive: inactiveUsers,
    active: activeUsers,
    graph: '/graph/users-solid-ocean-green.png',
    name: 'last name',
    match: (value) => false,
  },
  'username': {
    inactive: inactiveUser,
    active: activeUser,
    graph: '/graph/user-solid-slate-blue.png',
    name: 'username',
    match: (value) => false,  // TODO
  },
  'email': {
    inactive: inactiveAt,
    active: activeAt,
    graph: '/graph/at-solid-celadon.png',
    name: 'email',
    match: (value) => validator.isEmail(value),
  },
  'email_provider': {
    inactive: inactiveAt,
    active: activeAt,
    graph: '/graph/at-solid-celadon.png',
    name: 'email provider',
    match: (value) => validator.isEmail(value),
  },
  'email_username': {
    inactive: inactiveAt,
    active: activeAt,
    graph: '/graph/at-solid-celadon.png',
    name: 'email username',
    match: (value) => validator.isEmail(value),
  },
  'phone_number': {
    inactive: inactivePhone,
    active: activePhone,
    graph: '/graph/phone-alt-solid-gamboge.png',
    name: 'phone number',
    match: (value) => validator.isMobilePhone(value),
  },
  'user_id': {
    inactive: inactiveId,
    active: activeId,
    graph: '/graph/circle-solid-gamboge.png',
    name: 'user id',
    match: (value) => false
  },
  'online_account': {
    inactive: inactiveChrome,
    active: activeChrome,
    graph: '/graph/circle-solid-gamboge.png',
    name: 'online account',
    match: (value) => false,
  },
  'pipl_person': {
    inactive: inactiveFacebook,
    active: activeFacebook,
    graph: '/graph/user-solid-slate-green.png',
    name: 'person',
    match: (value) => false,
  },
  'pipl_person_partial_match': {
    inactive: inactiveFacebook,
    active: activeFacebook,
    graph: '/graph/user-solid-slate-green2.png',
    name: 'partial matched person',
    match: (value) => false,
  },
  'pipl_person_related': {
    inactive: inactiveFacebook,
    active: activeFacebook,
    graph: '/graph/user-solid-slate-yellow.png',
    name: 'related person',
    match: (value) => false,
  },
  'continent': {
    inactive: inactiveCircle,
    active: activeCircle,
    graph: '/graph/splotch-solid-slate-blue.png',
    name: 'continent',
    match: (value) => false,  // TODO
  },
  'country': {
    inactive: inactiveFlag,
    active: activeFlag,
    graph: '/graph/circle-solid-gamboge.png',
    name: 'country',
    match: (value) => false,  // TODO
  },
  'postal_code': {
    inactive: inactiveEnvelope,
    active: activeEnvelope,
    graph: '/graph/circle-solid-gamboge.png',
    name: 'postal code',
    match: (value) => false,
  },
  'address': {
    inactive: inactiveAddress,
    active: activeAddress,
    graph: '/graph/circle-solid-gamboge.png',
    name: 'address',
    match: (value) => false,
  },
  'city': {
    inactive: inactiveCity,
    active: activeCity,
    graph: '/graph/city-solid-celadon.png',
    name: 'city',
    match: (value) => false,
  },
  'fax': {
    inactive: inactiveFax,
    active: activeFax,
    graph: '/graph/circle-solid-gamboge.png',
    name: 'fax',
    match: (value) => false,
  },
  'data_breach': {
    inactive: inactiveDatabase,
    active: activeDatabase,
    graph: '/graph/database-solid-slate-blue.png',
    name: 'data breach',
    match: (value) => false,  // TODO
  },
  'asn': {
    inactive: inactiveCubes,
    active: activeCubes,
    graph: '/graph/circle-solid-gamboge.png',
    name: 'asn',
    match: (value) => value.match(/^(^AS)?[0-9]+$/)
  },
  'domain': {
    inactive: inactiveDomain,
    active: activeDomain,
    graph: '/graph/globe-europe-solid-celadon.png',
    name: 'domain',
    match: (value) => value.match(/^([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,6}$/),
  },
  'domain_port': {
    inactive: inactiveStar,
    active: activeStar,
    graph: '/graph/circle-solid-gamboge.png',
    name: 'domain port',
    match: (value) => false,  // TODO
  },
  'ip': {
    inactive: inactiveIp,
    active: activeIp,
    graph: '/graph/laptop-solid-gamboge.png',
    name: 'ip',
    match: (value) => validator.isIP(value),
  },
  'ip_port': {
    inactive: inactivePin,
    active: activePin,
    graph: '/graph/circle-solid-gamboge.png',
    name: 'IP port',
    match: (value) => false,  // TODO
  },
  'ip_class': {
    inactive: inactiveCubes,
    active: activeCubes,
    graph: '/graph/circle-solid-gamboge.png',
    name: 'ip class',
    match: (value) => value.match(/^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}0\/24$/),
  },
  'isp': {
    inactive: inactiveCircle,
    active: activeCircle,
    graph: '/graph/circle-solid-gamboge.png',
    name: 'isp',
    match: (value) => false,  // TODO
  },
  'organization_name': {
    inactive: inactiveBuilding,
    active: activeBuilding,
    graph: '/graph/building-solid-ocean-green.png',
    name: 'organization name',
    match: (value) => false,  // TODO
  },
  'url': {
    inactive: inactiveURL,
    active: activeURL,
    graph: '/graph/file-code-solid-slate-blue.png',
    name: 'url',
    match: (value) => value.match(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/),
  },
  'keyword': {
    inactive: inactiveQuote,
    active: activeQuote,
    graph: '/graph/key-solid-gamboge.png',
    name: 'keyword',
    match: (value) => false,
  },
  'onion': {
    inactive: inactiveDomain,
    active: activeDomain,
    graph: '/graph/globe-europe-solid-celadon.png',
    name: 'onion',
    match: (value) => value.match(/^[a-z0-9]{16}\.onion$/),
  },
  'md5': {
    inactive: inactiveFile,
    active: activeFile,
    graph: '/graph/file-solid-gamboge.png',
    name: 'md5',
    match: (value) => value.match(/^[a-fA-F0-9]{32}$/),
  },
  'sha1': {
    inactive: inactiveHash,
    active: activeHash,
    graph: '/graph/hashtag-solid-gamboge.png',
    name: 'sha1',
    match: (value) => value.match(/^[0-9a-fA-F]{40}$/),
  },
  'sha256': {
    inactive: inactiveHash,
    active: activeHash,
    graph: '/graph/hashtag-solid-gamboge.png',
    name: 'sha256',
    match: (value) => value.match(/^[0-9a-fA-F]{64}$/),
  },
  'http_header_etag': {
    inactive: inactiveNewspaper,
    active: activeNewspaper,
    graph: '/graph/circle-solid-gamboge.png',
    name: 'http header etag',
    match: (value) => false,
  },
  'cve': {
    inactive: inactiveExclamation,
    active: activeExclamation,
    graph: '/graph/exclamation-circle-solid-ocean-green.png',
    name: 'cve',
    match: (value) => value.match(/^cve-[0-9]{4}-[0-9]{4,}$/),
  },
  'cwe': {
    inactive: inactiveSitemap,
    active: activeSitemap,
    graph: '/graph/sitemap-solid-celadon.png',
    name: 'cwe',
    match: (value) => false,
  },
  'msb': {
    inactive: inactiveCircle,
    active: activeCircle,
    graph: '/graph/circle-solid-gamboge.png',
    name: 'msb',
    match: (value) => false,
  },
  'bid': {
    inactive: inactiveCircle,
    active: activeCircle,
    graph: '/graph/circle-solid-gamboge.png',
    name: 'bid',
    match: (value) => false,
  },
  'osvdb': {
    inactive: inactiveCircle,
    active: activeCircle,
    graph: '/graph/circle-solid-gamboge.png',
    name: 'osvdb',
    match: (value) => false,
  },
  'software_product': {
    inactive: inactiveCube,
    active: activeCube,
    graph: '/graph/circle-solid-gamboge.png',
    name: 'software product',
    match: (value) => false,
  },
  'software_product_version': {
    inactive: inactiveCube,
    active: activeCube,
    graph: '/graph/circle-solid-gamboge.png',
    name: 'software product version',
    match: (value) => false,
  },
  'software_vendor': {
    inactive: inactiveSuitcase,
    active: activeSuitcase,
    graph: '/graph/circle-solid-gamboge.png',
    name: 'software vendor',
    match: (value) => false,
  },
  'tls_certificate_sha1': {
    inactive: inactiveKey,
    active: activeKey,
    graph: '/graph/circle-solid-gamboge.png',
    name: 'tls certificate sha1',
    match: (value) => false,
  },
  'document': {
    inactive: inactiveFilePdf,
    active: activeFilePdf,
    graph: '/graph/file-pdf-solid-ocean-green.png',
    name: 'document',
    match: (value) => false,
  },
  'cryptocurrency': {
    inactive: inactiveBitcoin,
    active: activeBitcoin,
    graph: '/graph/bitcoin.png',
    name: 'bitcoin address',
    match: (value) => { return value.length >= 27 && value.length <= 34 && value.match(/^(1|3|bc1)[a-zA-Z0-9]*$/) },
  },
  'cryptocurrency_tx': {
    inactive: inactiveBolt,
    active: activeBolt,
    graph: '/graph/bolt-solid-bitcoin.png',
    name: 'bitcoin transaction',
    match: (value) => value.match(/^[0-9a-fA-F]{64}$/),
  },
  'ethereum-address': {
    inactive: inactiveEthereum,
    active: activeEthereum,
    graph: '/graph/ethereum.png',
    name: 'ethereum address',
    match: (value) => value.match(/^0x[a-fA-F0-9]{40}$/),
  },
  'ethereum-tx': {
    inactive: inactiveBolt,
    active: activeBolt,
    graph: '/graph/bolt-solid-ethereum.png',
    name: 'ethereum transaction',
    match: (value) => value.match(/^0x([A-Fa-f0-9]{64})$/),
  },
};
